// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20O50","colBig":"styles_colBig__1tMOY","colSmall":"styles_colSmall__1y8UE"};